import { render, staticRenderFns } from "./dealCenter.vue?vue&type=template&id=89f8d8b8&scoped=true"
import script from "./dealCenter.vue?vue&type=script&lang=js"
export * from "./dealCenter.vue?vue&type=script&lang=js"
import style0 from "./dealCenter.vue?vue&type=style&index=0&id=89f8d8b8&prod&scoped=true&lang=css"
import style1 from "./dealCenter.vue?vue&type=style&index=1&id=89f8d8b8&prod&lang=css"
import style2 from "./dealCenter.vue?vue&type=style&index=2&id=89f8d8b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f8d8b8",
  null
  
)

export default component.exports